<div class="container default-container">
    <div class="plus-map">
        <div>
            <div id="map" style="width: 100%; height: 550px;"></div>
        </div>
        <div class="list-center">
            <div>
                총 {{ filteredLocations.length }}개의 검색 결과가 있습니다
            </div>
            <ul>
                <input class="mt-2 mb-3" id="search" type="text" [(ngModel)]="searchQuery" (input)="onInput($event)"
                    (compositionstart)="onCompositionStart()" (compositionend)="onCompositionEnd($event)"
                    (compositionupdate)="onCompositionUpdate($event)" placeholder="검색어를 입력하세요." style="width: 95%;">
                <li *ngFor="let item of filteredLocations; index as i" (click)="selectPlace(item)"
                    style="cursor: pointer;">
                    <div style="display: flex;">
                        <div style="flex: 3;">
                            <div>{{ item.cntName }}</div>
                            <div>{{ item.addr1 }}{{ValidationUtil.isNullOrEmpty(item.addr2) ? '' :',' + item.addr2}}</div>
                            <!-- <div>{{ item.regDate }}</div> -->
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</div>